export default "__VITE_ASSET__8fpWAxFM__"